const state = {
  guest: true
};

const getters = {
  guest: state => {
    return state.guest;
  }
};

const mutations = {
  toggleGuest: state => {
    state.guest = !state.guest;
  },
  updateGuest: state => {
    console.log('UPD GUEST', localStorage.getItem('user-token'))
    state.guest = localStorage.getItem('user-token') ? false : true;
  }
};

export default {
  state,
  getters,
  mutations
};



//////////////////
// WEBPACK FOOTER
// ./store/modules/login.js
// module id = null
// module chunks = 